var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 7.33331C1.2665 7.33331 0.666504 7.93331 0.666504 8.66665V13.3333C0.666504 14.0666 1.2665 14.6666 1.99984 14.6666C2.73317 14.6666 3.33317 14.0666 3.33317 13.3333V8.66665C3.33317 7.93331 2.73317 7.33331 1.99984 7.33331ZM13.3265 11.3333H8.77317C8.69984 11.3333 8.6265 11.32 8.55317 11.2933L7.57317 10.9533C7.39984 10.8933 7.31317 10.7066 7.37317 10.5333C7.43317 10.36 7.6265 10.2666 7.79984 10.3333L8.5465 10.62C8.61984 10.6466 8.7065 10.6666 8.7865 10.6666H10.5398C10.9732 10.6666 11.3265 10.3133 11.3265 9.87998C11.3265 9.55331 11.1198 9.25998 10.8132 9.13998L6.19984 7.41998C6.05317 7.35998 5.89317 7.33331 5.73317 7.33331H4.6665V13.3466L8.91317 14.5533C9.1865 14.6333 9.47984 14.62 9.7465 14.52L14.6665 12.6666C14.6665 11.9266 14.0665 11.3333 13.3265 11.3333Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3328 7.78332L10.8495 7.34332C9.13285 5.78666 7.99951 4.75999 7.99951 3.49999C7.99951 2.47332 8.80618 1.66666 9.83284 1.66666C10.4128 1.66666 10.9695 1.93666 11.3328 2.36332C11.6962 1.93666 12.2528 1.66666 12.8328 1.66666C13.8595 1.66666 14.6662 2.47332 14.6662 3.49999C14.6662 4.75999 13.5328 5.78666 11.8162 7.34666L11.3328 7.78332Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.d99743bb.svg";
export { ForwardRef as ReactComponent };